<template>
  <div class="app-wrapper">
    <sidebar class="sidebar-container"/>
   <div class="main-container">
      <app-main/>
    </div>
  </div>
</template>
<script>
import { sidebar,appMain } from "./components";

export default {
  name: "layout",
  components: { sidebar,appMain  },
  computed: {
    message() {
      return "网管说这个页面你不能进......";
    }
  },
  methods: {
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    }
  }
};
</script>

<style lang="scss">
.app-wrapper {
    position: relative;
    height: 100%;
    width: 100%;
    &.mobile.openSidebar{
      position: fixed;
      top: 0;
    }
  }
.el-scrollbar__wrap {
  overflow: visible !important;
  overflow-x: hidden !important;
}
// 侧边栏
.sidebar-container {
  transition: width 0.28s;
  width: 180px;
  height: 100%;
  position: fixed !important;
  bottom: 0;
  top: 0;
  left: 0;
  z-index: 1001;
}
.el-scrollbar__view {
  height: 100%;
}
.el-menu {
  height: 100%;
   width: 100% !important;
   border: none;
}

a,
a:focus,
a:hover {
  cursor: pointer;
  color: inherit;
  outline: none;
  text-decoration: none;
}
.svg-icon {
  margin-right: 16px;
}
 // 主体区域
  .main-container {
    min-height: 100%;
    transition: margin-left .28s;
    margin-left: 180px;
    position: relative;
  }
</style>




// WEBPACK FOOTER //
// src/views/layout/Layout.vue